const EMAIL_SEND_PATH = '/email-send';

const INVITE_PURPOSE = 'invite_extended';

export {
  EMAIL_SEND_PATH,
  INVITE_PURPOSE,
};
